function CtaBanner() {
  return (
    <div className="w-full md:mt-0 mt-10 ">
      <div className="w-full bg-[#6A3FFF] relative overflow-hidden">
        {/* Decorative swoosh shapes */}
        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            d="M0,260 C300,180 500,340 820,240 C1100,150 1250,300 1440,220 L1440,320 L0,320 Z"
            className="fill-white/10"
          ></path>
          <path
            d="M300,0 C500,60 650,-20 900,40 C1100,90 1250,10 1440,60 L1440,0 L300,0 Z"
            className="fill-white/10"
          ></path>
        </svg>

        {/* Decorative blobs */}
        <div className="absolute -top-20 -left-10 w-72 h-72 bg-white opacity-10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-24 right-0 w-96 h-96 bg-white opacity-10 rounded-full blur-3xl"></div>

        <div className="project-container relative px-4 py-18 md:py-24 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          {/* Left side */}
          <div className="text-center md:text-left">
            <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-4">
              Testen Sie Jobdaten heute noch.

              <br className="hidden md:block" /> kostenlos und ohne Verpflichtung.
            </h2>
            <div className="flex flex-col md:flex-row items-center md:items-center gap-3 md:gap-6 justify-center md:justify-start">
              <span className="flex items-center gap-2 text-white/90 text-sm md:text-base">
                <span className="w-5 h-5 rounded-full border border-white/70 flex items-center justify-center text-xs">
                  ✓
                </span>
                Keine Kreditkarte erforderlich
              </span>
              <span className="flex items-center gap-2 text-white/90 text-sm md:text-base">
                <span className="w-5 h-5 rounded-full border border-white/70 flex items-center justify-center text-xs">
                  ✓
                </span>
                Keine Verpflichtung
              </span>
            </div>
          </div>

          {/* Right side - Button */}
          <div className="flex-shrink-0 text-center">
            <a href="/demo">
              <button className="px-8 py-3 rounded-full bg-white text-[#6A3FFF] font-semibold transform transition-all duration-300 hover:scale-105 hover:shadow-2xl active:scale-95 focus:outline-none focus:ring-4 focus:ring-white/40">
                Jetzt ausprobieren
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CtaBanner;
